import { useQuery } from "react-query";
import { getEntityOptions } from "src/utils/api/dashboard";
import { ENTITY_ROLE_NAME } from "src/constants/common";

export const ENTITY_OPTIONS_QUERY_KEY = ["entityOptions"] as const;

export const useEntityOptions = () => {
  const { data, isFetching } = useQuery(
    ENTITY_OPTIONS_QUERY_KEY,
    () =>
      getEntityOptions({
        role: ENTITY_ROLE_NAME,
        status: "ACTIVE",
      }),
    {
      staleTime: 30 * 60 * 1000,
      cacheTime: 60 * 60 * 1000,
      refetchOnMount: false,
    }
  );

  return {
    entityInfo: data?.data?.rows ?? [],
    isFetching,
  };
};

export default useEntityOptions;
